import { Expose, Type } from 'class-transformer';

import { QuarteredForecastPart } from './QuarteredForecastPart';

export class QuarteredForecast {
  @Expose({ name: 'day_of_week' })
  dayOfWeek: string;

  @Type(() => Date)
  date: Date;

  @Expose({ name: 'temperature_high' })
  temperatureHigh: number;

  @Expose({ name: 'temperature_low' })
  temperatureLow: number;

  @Expose({ name: 'icon_url' })
  icon: string;

  @Expose({ name: 'description' })
  description: string;

  @Expose({ name: 'magnetic_field' })
  magneticField: number;

  @Expose({ name: 'water_temperature' })
  waterTemperature?: number;

  @Type(() => QuarteredForecastPart)
  night: QuarteredForecastPart;

  @Type(() => QuarteredForecastPart)
  morning: QuarteredForecastPart;

  @Type(() => QuarteredForecastPart)
  day: QuarteredForecastPart;

  @Type(() => QuarteredForecastPart)
  evening: QuarteredForecastPart;
}
